const Data = [
 {
   "id": 1,
   "name": "Connor Watson ",
   "club": "Knights ",
   "pos": "HOK",
   "position1": "Hooker",
   "position2": "5/8",
   "scprice": "$288,600",
   "sc2020ave": "36.2",
   "experts": "Connor Watson has emerged as close to a must have after scoring the No. 13 jumper at Newcastle. Watson has averaged 57 for KFC SuperCoach in the past, but is priced on a 36 average following an injury-ruined season. Translation: Muchos money to be made. ",
   "imagename": "Connor-Watson"
 },
 {
   "id": 2,
   "name": "Jacob Liddle ",
   "club": "Tigers ",
   "pos": "HOK",
   "position1": "Hooker (Bench)",
   "position2": "N/A",
   "scprice": "$247,200",
   "sc2020ave": "31",
   "experts": "Wests Tigers hooker Jacob Liddle is the biggest KFC SuperCoach winner from the round one teams after seemingly scoring an 80-minute hooker role at the Tigers. Liddle had been head-to-head with young gun Jake Simpkin all pre-season, with Simpkin even starting ahead of Liddle in a recent trial. But Simpkin has missed the squad altogether, apparently guaranteeing Liddle a full game in the No.9 jersey, despite a horror run of injuries since his debut in 2016. However, KFC SuperCoaches should be aware that Adam Doueihi is back in round two meaning Moses Mbye may move from five-eighth to a bench utility/hooker role, which would limit Liddle’s minutes. Even if that eventuates, Liddle is still set for a huge increase on his average game time of 30 minutes last year.",
   "imagename": "Jacob-Liddle"
 },
 {
   "id": 3,
   "name": "Tino Fa'asuamaleaui ",
   "club": "Titans ",
   "pos": "FRF",
   "position1": "Front Rower",
   "position2": "2nd Row Forward",
   "scprice": "$504,900",
   "sc2020ave": "57",
   "experts": "Only classed as a 2RF last year, Big Tino has picked up dual status after playing mostly as a middle at the Storm. With a strong Origin campaign under his belt and now at the Titans, Fa’asuamaleaui has a huge chance to improve on his average of 46 minutes per game. Of course, he won’t have Cameron Smith putting him through holes, but he can more than make up for that with extra game time. ",
   "imagename": "Tino"
 },
 {
   "id": 4,
   "name": "Christian Welch",
   "club": "Storm ",
   "pos": "FRF",
   "position1": "Front Rower",
   "position2": "N/A",
   "scprice": "$453,500",
   "sc2020ave": "51.19",
   "experts": "The injury to Dale Finucane (calf, round six) makes Welch a near-must. He has been named to start at prop and should see big minutes — on top of being priced at a 10-point discount on what we can expect this season due to easing back from an ACL injury last year. Perfect sleeper who may even become a keeper. ",
   "imagename": "Christian-Welch"
 },
 {
   "id": 5,
   "name": "Stefano Utoikamanu ",
   "club": "Tigers ",
   "pos": "FRF",
   "position1": "Front Rower (Bench)",
   "position2": "N/A",
   "scprice": "$186,800",
   "sc2020ave": "14.33",
   "experts": "Big Stefano was frozen out by the Eels last year after signing a big-money deal with the Tigers and he therefore starts essentially at bottom dollar. One of the most-hyped prop prospects in the NRL and a key buy for the Tigers, Utoikamanu is all but assured to improve on his average game time of just eight minutes, even with James Tamou and Joe Ofahengaue also joining the middle rotation at the Tigers. Strong in the trials. ",
   "imagename": "Stefano"
 },
 {
   "id": 6,
   "name": "Spencer Leniu ",
   "club": "Panthers ",
   "pos": "FRF",
   "position1": "Front Rower (Bench)",
   "position2": "N/A",
   "scprice": "$218,500",
   "sc2020ave": "24.67",
   "experts": "The Panthers have prop game time to fill following the exits of James Tamou (average 43 minutes last year) and Zane Tetevano (32 minutes), with young gun Spencer Leniu set to step up after averaging just 20 minutes last year. His PPM is insane at 1.21 so any small increase in minutes should lead to a big rise in KFC SuperCoach production. ",
   "imagename": "Spencer-Leniu"
 },
 {
   "id": 7,
   "name": "Ryan Matterson ",
   "club": "Eels ",
   "pos": "2RF",
   "position1": "2nd Row Forward",
   "position2": "N/A",
   "scprice": "$666,000",
   "sc2020ave": "75.18",
   "experts": "There is no player in the game with a higher floor than Matterson. Removing the game he got knocked out and left the field after 15 minutes, Matto’s lowest score last year was 60, which puts far more popular keepers to shame including Nathan Cleary, Cameron Munster, James Tedesco and Jason Taumalolo. ",
   "imagename": "Ryan-Matterson"
 },
 {
   "id": 8,
   "name": "Jason Taumalolo ",
   "club": "Cowboys ",
   "pos": "2RF",
   "position1": "2nd Row Forward",
   "position2": "N/A",
   "scprice": "$641,700",
   "sc2020ave": "72.44",
   "experts": "Once the third most popular player in KFC SuperCoach early in the pre-season, Taumalolo has drifted outside the top 20, despite not averaging under 70 in four years. Why? Because new coach Todd Payten has confirmed Lolo will play less minutes, ball-play more and spend stints on the edge. This is all concerning for KFC SuperCoach, but Lolo is Lolo and he’s essentially a POD (for him) as it currently stands. It would take a brave KFC SuperCoach to predict he finish outside the top five in the back row, so lock him in now and save the trade — and enjoy the POD(ish) ride. ",
   "imagename": "Jason-Taumalolo"
 },
 {
   "id": 9,
   "name": "Angus Crichton ",
   "club": "Roosters ",
   "pos": "2RF",
   "position1": "2nd Row Forward",
   "position2": "N/A",
   "scprice": "$670,500",
   "sc2020ave": "75.7",
   "experts": "Angus Crichton was already a good buy before Cameron McInnes and Payne Haas copped the wrath of the KFC SuperCoach gods, but now he’s a near must-have. Confirmed to fill the left edge back row role of Boyd Cordner (concussion, round 12), Crichton is actually under-priced after easing back from injury last season and only averaging 70 minutes for the year.",
   "imagename": "Angus-Crichton"
 },
 {
   "id": 10,
   "name": "Joe Ofahengaue",
   "club": "Tigers ",
   "pos": "2RF",
   "position1": "2nd Row Forward (Bench)",
   "position2": "Front Rower",
   "scprice": "$340,800",
   "sc2020ave": "38.5",
   "experts": "Somewhat frozen out by the Broncos last year, Big Ofa joins the Tigers as a key signing and should see an increased role. After being switched between bench, prop and edge last year, he finally looks set for a regular position after being named starting prop for the Tigers in Round 1. Expect big improvement.",
   "imagename": "Joe-Ofahengaue"
 },
 {
   "id": 11,
   "name": "Jordan Riki ",
   "club": "Broncos ",
   "pos": "2RF",
   "position1": "2nd Row Forward (Bench)",
   "position2": "N/A",
   "scprice": "$277,500",
   "sc2020ave": "34.8",
   "experts": "The departure of David Fifita leaves a huge hole on the Broncos’ right edge and Riki is the beneficiary. While eased in minutes-wise last year, Riki looked good to the eye and even banged out an 80-minute game in the final round for 54 points in pure base. Hopefully this will be a regular occurrence in 2021. Phenomenal in for the Maori All Stars in pre-season.  ",
   "imagename": "Jordan-Riki"
 },
 {
   "id": 12,
   "name": "Jacob Host ",
   "club": "Rabbitohs",
   "pos": "2RF",
   "position1": "2nd Row Forward (Bench)",
   "position2": "N/A",
   "scprice": "$317,100",
   "sc2020ave": "35.8",
   "experts": "Appears to have won the trust of coach Wayne Bennett after being named to start on an edge in round one. Host is hardly a noted KFC SuperCoach player, but bargains are hard to come by in the back row so he gets a slot in the Sangster's Paradise squad for now. Will surely improve on an average of 43 minutes from last season if he starts in the back row all year. ",
   "imagename": "Jacob-Host"
 },
 {
   "id": 13,
   "name": "Nathan Cleary ",
   "club": "Panthers ",
   "pos": "HFB",
   "position1": "Halfback",
   "position2": "N/A",
   "scprice": "$734,300",
   "sc2020ave": "82.89",
   "experts": "Almost 15 points per game better than the next best halfback in KFC SuperCoach last year and worth every cent of his premium price. Don’t overthink it. ",
   "imagename": "Nathan-Cleary"
 },
 {
   "id": 14,
   "name": "Sam Walker ",
   "club": "Roosters ",
   "pos": "HFB",
   "position1": "Halfback (Bench)",
   "position2": "N/A",
   "scprice": "$173,700",
   "sc2020ave": "N/A",
   "experts": "Bit of a hit and hope. Sam Walker won’t start the year. Rather, Luke Keary switches to halfback with Lachlan Lam at five-eighth. However, Walker is a serious prodigy, compared to a young Kalyn Ponga on talent, and will likely play first grade at some stage. Further, there are literally NO other cheapies at halfback, with the next value buy being Chanel Harris-Tavita for $250,000 more. ",
   "imagename": "Sam-Walker"
 },
 {
   "id": 15,
   "name": "Cody Walker ",
   "club": "Rabbitohs",
   "pos": "5/8",
   "position1": "5/8",
   "position2": "N/A",
   "scprice": "$656,000",
   "sc2020ave": "74.1",
   "experts": "Cameron Munster is a KFC SuperCoach great, but I still think he’s over-owned as the 11th most popular player at 34 per cent ownership. For me it’s a 50-50 call between Munster and Cody Walker for the gun five-eighth slot, yet Walker has less than half the ownership (15.9 per cent). Sangster’s Paradise will take the POD any day. The big question is whether he Cody continues in a sweeping role. Walker scooted away to a five-game average of 112 to end the season, playing more as a traditional halfback on both sides of the field and essentially winning SC champion Joe Naddaf the $50,000. I don’t expect Walker to roam as much with Latrell Mitchell back in the team, but the blueprint is proven and Wayne Bennett would be mad to switch it up too much.",
   "imagename": "Cody-Walker"
 },
 {
   "id": 16,
   "name": "Matt Moylan ",
   "club": "Sharks ",
   "pos": "5/8",
   "position1": "5/8 (Bench)",
   "position2": "Fullback",
   "scprice": "$253,600",
   "sc2020ave": "28.63",
   "experts": "Retains dual status after playing three games at fullback, four at five-eighth and one off the bench. What’s more, he starts in the borderline cheapie range after a horror, injury-affected season. Obviously there is huge risk with this buy, but he’s averaged 60s in KFC SuperCoach in the past and is hard to ignore at the price. Confirmed to play five-eighth in place of Shaun Johnson (Achilles, round eight) over the opening rounds. ",
   "imagename": "Matt-Moylan"
 },
 {
   "id": 17,
   "name": "Daine Laurie",
   "club": "Tigers ",
   "pos": "CTW",
   "position1": "Wing/Centre",
   "position2": "Fullback ",
   "scprice": "$223,200",
   "sc2020ave": "28",
   "experts": "Currently the fifth most popular player after scoring the fullback spot at the Tigers — for the upcoming round at least. However, job security is an issue given Adam Doueihi (suspension) is due back next week and confirmed the five-eighth role, which could see Moses Mbye move from the halves and take Laurie’s fullback spot. Or as mentioned above, Mbye could cut into Liddle's minutes. Either way, there are questions marks, but both are worth the risk.",
   "imagename": "Daine-Laurie"
 },
 {
   "id": 18,
   "name": "Charlie Staines ",
   "club": "Panthers ",
   "pos": "CTW",
   "position1": "Wing/Centre",
   "position2": "Fullback",
   "scprice": "$297,700",
   "sc2020ave": "112",
   "experts": "The most popular player in KFC SuperCoach at over 50 per cent ownership. The appeal is undeniable — Staines scored six tries in just 107 minutes of NRL last year and scores a round one wing spot following Josh Mansour’s defection to the Rabbitohs. ",
   "imagename": "Charlie-Staines"
 },
 {
   "id": 19,
   "name": "David Fusitua",
   "club": "Warriors ",
   "pos": "CTW",
   "position1": "Wing/Centre",
   "position2": "N/A",
   "scprice": "$251,800",
   "sc2020ave": "28.43",
   "experts": "Coming off a tough year where he scored just one try in seven games before leaving the Warriors’ bubble and returning to New Zealand for family reasons. He averaged a lowly 28 KFC SuperCoach points and therefore starts cheap, but expect significant improvement based on past output – he averaged 37, 48, 42 and 51 in the previous four seasons. ",
   "imagename": "David-Fusitua"
 },
 {
   "id": 20,
   "name": "Jason Saab ",
   "club": "Sea Eagles ",
   "pos": "CTW",
   "position1": "Wing/Centre",
   "position2": "N/A",
   "scprice": "$233,200",
   "sc2020ave": "29.25",
   "experts": "Saab has scored a wing spot for round one given Jorge Taufua (Achilles) and Tom Trbojevic (hamstring) are both unavailable. With a career average in the high 30s so far, expect a solid-ish price increase. But the main appeal is job security.",
   "imagename": "Jason-Saab"
 },
 {
   "id": 21,
   "name": "Tesi Niu",
   "club": "Broncos ",
   "pos": "CTW",
   "position1": "Wing/Centre (Bench)",
   "position2": "Fullback",
   "scprice": "$232,500",
   "sc2020ave": "29.17",
   "experts": "Niu has been called Brisbane’s “best fullback prospect since Darren Lockyer”, but has won the right centre spot vacated by Kotoni Staggs (ACL). Starts the season at near base price and is one of the safest cheapies in KFC SuperCoach, so lock him in. Fifth most popular player.",
   "imagename": "Tesi-Niu"
 },
 {
   "id": 22,
   "name": "Bailey Simonsson",
   "club": "Raiders ",
   "pos": "CTW",
   "position1": "Wing/Centre (Bench)",
   "position2": "N/A",
   "scprice": "$205,000",
   "sc2020ave": "23.14",
   "experts": "As predicted, Simonsson has won the Canberra wing spot vacated by Nick Cotric (Bulldogs). His price is based on a season average of 23.1, which is way down due to stints on the bench. His 2019 average of 38 is a more accurate representation of what we can expect.  ",
   "imagename": "Bailey-Simonsson"
 },
 {
   "id": 23,
   "name": "James Roberts ",
   "club": "Tigers  ",
   "pos": "CTW",
   "position1": "Wing/Centre (Bench)",
   "position2": "N/A",
   "scprice": "$277,700",
   "sc2020ave": "34.83",
   "experts": "James Roberts has had an up-and-down career. Some amazing highs (like his 60 average in 2017) and also some rather large lows including on-and-off-field issues. Last year was one of those down years meaning KFC SuperCoaches are presented with Jimmy The Jet at a bargain price, at a new club, with Nofo outside him and with potential to burn. His price can’t get any lower, surely. ",
   "imagename": "James-Roberts"
 },
 {
   "id": 24,
   "name": "James Tedesco",
   "club": "Roosters ",
   "pos": "FLB",
   "position1": "Fullback",
   "position2": "N/A",
   "scprice": "$843,100",
   "sc2020ave": "95.18",
   "experts": "Most points of any player last year despite missing three games. I’m more than willing to pay the premium. ",
   "imagename": "James-Tedesco"
 },
 {
   "id": 25,
   "name": "Ryan Papenhuyzen ",
   "club": "Storm ",
   "pos": "FLB",
   "position1": "Fullback (Bench)",
   "position2": "N/A",
   "scprice": "$629,000",
   "sc2020ave": "71",
   "experts": "With Tom Trbojevic injured, Papenhuyzen is the obvious replacement, especially after scoring the goalkicking duties of the departed Cameron Smith. Paps got off to a slow start in 2020, struggling to gel with Cam Munster. But things started to click from round seven onwards and in 11 games from that point Papenhuyzen averaged 84, exceeding 100 points five times. He’s not quite Teddy class yet, but Papenhuyzen’s not far away and he is $200K cheaper. ",
   "imagename": "Ryan-Papenhuyzen"
 }
]
export default Data


// WEBPACK FOOTER //
// ./src/components/Data.js